module.exports = __webpack_public_path__ + "img/488.9349544d.png";